import { API } from "./ApiURL";
import { BASEURL, FEEDBACK_SHEET_URL } from "./constant";

export const getSubscriptionPlan = async () => {
    try {
        const res = await fetch(`${BASEURL}${API.SUBSCRIPTIONPLAN}`);
        const data = await res.json();
        return data;
    } catch (error) {
        console.log('error', error)
    }
}

export const createOrderAPI = async (data, accessToken) => {
    try {
        const res = await fetch(`${BASEURL}${API.CREATE_ORDER}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        })
        const responseData = await res.json();
        console.log('responseData', responseData)
        return responseData;
    } catch (error) {
        console.log('error', error)
    }
}

export const completePaymentAPI = async (data, accessToken) => {
    try {
        const res = await fetch(`${BASEURL}${API.COMPLETE_PAYMENT}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        })
        const responseData = await res.json();
        return responseData;
    } catch (error) {
        console.log('error', error)
    }
};


export const sendOtpAPI = async (credentials) => {
    try {
        const response = await fetch(`${BASEURL}${API.SEND_OTP}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify(credentials)
        })
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log('error', error)
    }
}

export const registerUserAPI = async (registerData) => {
    try {
        const response = await fetch(`${BASEURL}${API.REGISTER_USER}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify(registerData)
        })
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log('error', error)
    }
}

// Submit feedback to Google Sheet via Google Apps Script Web App.
export const submitFeedbackToSheet = async (payload) => {
    try {
        const response = await fetch(FEEDBACK_SHEET_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: payload.name || '',
                message: payload.message || '',
                phone: payload.phone || '',
                source: payload.source || '',
                timestamp: new Date().toISOString(),
            }),
        })
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log('error', error)
    }
}